module.exports = __webpack_public_path__ + "img/cell.png?8057134dc1459454a513f82835b6a50d";